/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PlaytimeByPlatform
 */
export interface PlaytimeByPlatform {
    /**
     * Minutes played on PC (Overwolf).
     * @type {number}
     * @memberof PlaytimeByPlatform
     */
    pc?: number;
    /**
     * Minutes played on PlayStation (Discord presence).
     * @type {number}
     * @memberof PlaytimeByPlatform
     */
    playstation?: number;
    /**
     * Minutes played on Xbox (Discord presence).
     * @type {number}
     * @memberof PlaytimeByPlatform
     */
    xbox?: number;
}

/**
 * Check if a given object implements the PlaytimeByPlatform interface.
 */
export function instanceOfPlaytimeByPlatform(value: object): value is PlaytimeByPlatform {
    return true;
}

export function PlaytimeByPlatformFromJSON(json: any): PlaytimeByPlatform {
    return PlaytimeByPlatformFromJSONTyped(json, false);
}

export function PlaytimeByPlatformFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlaytimeByPlatform {
    if (json == null) {
        return json;
    }
    return {
        
        'pc': json['pc'] == null ? undefined : json['pc'],
        'playstation': json['playstation'] == null ? undefined : json['playstation'],
        'xbox': json['xbox'] == null ? undefined : json['xbox'],
    };
}

export function PlaytimeByPlatformToJSON(json: any): PlaytimeByPlatform {
    return PlaytimeByPlatformToJSONTyped(json, false);
}

export function PlaytimeByPlatformToJSONTyped(value?: PlaytimeByPlatform | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pc': value['pc'],
        'playstation': value['playstation'],
        'xbox': value['xbox'],
    };
}

